import { createApiHandler } from './handler';

const roles = {
  apiClient: null,
  path: '/franchises/roles',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getPermissions() {
    try {
      const response = await this.apiClient.get(`${this.path}/permissions`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default roles;
